import React, { useState } from 'react';
import { getFirstLetters } from 'services/helpers/user';
import { PencilIcon } from '@heroicons/react/24/solid';
import { Profile } from 'types/User';
import UserAvatar from '../UserAvatar';

interface Props {
  member: Profile;
  admin: boolean;
  onClick: (member: Profile) => void;
}

const Member: React.FC<Props> = ({ member, admin, onClick }) => {
  const [displayIcon, setDisplayIcon] = useState(false);
  return (
    <div
      onClick={() => admin && onClick(member)}
      onMouseEnter={() => setDisplayIcon(true)}
      onMouseLeave={() => setDisplayIcon(false)}
      key={member.email}
      className="p-4 flex w-full justify-between items-center hover:bg-blue-100"
    >
      <div className="flex space-x-4 items-center">
        <UserAvatar size="small" letters={getFirstLetters(member)} />
        <div className="flex flex-col space-y-1">
          <h4 className="text-dark">{`${member.first_name} ${member.last_name} ${
            member.is_admin ? '(Admin)' : '(Member)'
          }`}</h4>
          <h4>{member.email}</h4>
        </div>
      </div>
      {admin && displayIcon && <PencilIcon className="cursor-pointer h-4" />}
    </div>
  );
};
Member.displayName = 'Settings.Profile.CompanyMembers.Member';
export default Member;
